import React, { useState, useEffect, useContext } from 'react';
import { Button, SpaceBetween } from '@amzn/awsui-components-react-v3';
import {
  DownloadButtonAlign,
  NavigationHeaderStyle,
  AccuracyButtonNewStyle,
} from '../../styles/common_styles';
import { getJSClient } from '../js_client';
import { ChannelTypes, RegionLabelMap } from '../../constants/spotlight_elements';
import { AccuracyButton } from '../buttons/accuracy_button';
import { ProductLinesButton } from '../buttons/product_lines_button';
import { TimeFrameButton } from '../buttons/time_frame_button';
import { DispatchContext } from './context/spotcp-context';
import { REQUEST_SUBMITTED } from './actions/actionTypes';

const Navigation = (props) => {
  const dispatch = useContext(DispatchContext);

  let client;
  // state
  const [marketplaceIds, setMarketplaceIds] = useState([]);
  const [productLines, setProductLines] = useState({});
  const [productLine, setProductLine] = useState({});
  const [marketplaceId, setMarketplaceId] = useState(null);
  const [channel, setChannel] = useState(null);
  const [timeFrame, setTimeFrame] = useState(null);
  const [idToRegionMap, setIdToRegionMap] = useState({});
  const [endMonth, setEndMonth] = useState();
  const [startMonth, setStartMonth] = useState();
  const [submitDisabled, setSubmitDisabled] = useState(true);

  // helpers
  const setUpTimeFrameRange = () => {
    let d = new Date();
    setEndMonth(d.getFullYear() * 100 + d.getMonth());
    d.setMonth(d.getMonth() - 11); // 11 month ago
    setStartMonth(d.getFullYear() * 100 + d.getMonth());
  };

  const onMarketplaceConfigFetchSuccess = (response) => {
    // regionMap key/value example: {'NA': [{label: 'US', id: 1}, {label:'CA', id: 7}....]}
    let regionMap = JSON.parse(response.marketplaceConfig)
      .filter((mp) => mp.spotlightEnabled)
      .reduce((map, mp) => {
        let mpOption = { label: mp.detail, id: mp.id };
        let region = mp.region;
        region in map ? map[region].push(mpOption) : (map[region] = [mpOption]);
        return map;
      }, {});
    // convert regionMap to format that can be used as options in AccuracyButton
    let marketplaceIds = [];
    let toRegion = {};
    Object.entries(regionMap).map((entry) => {
      let [key, value] = entry;
      marketplaceIds.push({ label: RegionLabelMap[key], options: value });
      value.forEach((v) => (toRegion[v.id] = key));
    });
    setMarketplaceIds(marketplaceIds);
    setIdToRegionMap(toRegion);
  };

  // clear existing values in the form
  const clearForm = () => {
    setChannel(null);
    setMarketplaceId(null);
    setProductLines(null);
    setTimeFrame(null);
  };

  // gather all selected attributes and pass back to parent
  const submitForm = () => {
    let request = {
      marketplaceId,
      channelType: channel,
      productlines: productLine.gls,
      timeFrame: timeFrame.id.replace('/', ''),
      timeFrameLabel: timeFrame.label,
      region: idToRegionMap[marketplaceId],
    };
    dispatch({ type: REQUEST_SUBMITTED, payload: request });

    client.runSpotcpSummary(dispatch, request); // FA
    client.runSpotcpSummary(dispatch, {...request, useLA: true}); // LA
    client.runSpotcpAsinHistogramFaAndLa(dispatch, { ...request, component: 'total' });
    client.runSpotcpTrendFaAndLa(dispatch, request);
  };

  // effect
  useEffect(() => {
    client = getJSClient();
  });

  // one-off effect
  useEffect(() => {
    setUpTimeFrameRange();
    client.getMarketplaceConfig(onMarketplaceConfigFetchSuccess);
    client.getPlHierarchy(
      (result) => {
        setProductLines(result.root);
      },
      (error) => {
        console.log(error);
      },
      {}
    );
  }, []);

  // control if user can click submit button
  useEffect(() => {
    if (marketplaceId && channel && productLine && timeFrame) setSubmitDisabled(false);
  }, [marketplaceId, channel, productLine, timeFrame]);

  return (
    <div data-navigation-level="0">
      <div className="website-navigation-title awsui-util-font-size-3" style={NavigationHeaderStyle}>
        <b>Report Attributes</b>
      </div>
      {/* attributes start */}
      <div>
        <AccuracyButton
          text="Marketplace"
          items={marketplaceIds}
          onChange={(e) => setMarketplaceId(e.detail.selectedId)}
          selected={marketplaceId}
          disabled={false}
          required={true}
        />
      </div>
      <div>
        <AccuracyButton
          text="Channel"
          items={ChannelTypes}
          onChange={(e) => setChannel(e.detail.selectedId)}
          selected={channel}
          disabled={false}
          required={true}
        />
      </div>
      <div>
        <ProductLinesButton
          text="Product Lines"
          required={true}
          productLines={productLines}
          selected={productLine}
          onChange={(e) => setProductLine(e.detail.selectedOption)}
          multiselect={false}
        />
      </div>
      <div className={AccuracyButtonNewStyle}>
        <TimeFrameButton
          text="Time Frame"
          startMonth={startMonth}
          endMonth={endMonth}
          onChange={(e) => setTimeFrame(e.detail.selectedOption)}
          selected={timeFrame ? timeFrame.id : null}
          required={true}
          multiSelect={false}
        />
      </div>
      {/* attributes end */}
      <div className={DownloadButtonAlign}>
        <SpaceBetween direction="horizontal" size="xs">
          <Button variant="normal" onClick={clearForm} disabled={false}>Clear</Button>
          <Button variant="primary" onClick={submitForm} disabled={submitDisabled}>Submit</Button>
        </SpaceBetween>
      </div>
    </div>
  );
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/spotcp/navigation.jsx